// ============================================================
// REDIRECCIÓN TEMPORAL DE CHECKOUT A WHATSAPP
// Para revertir: borra este archivo y quita las 2 líneas en
// layout/theme.liquid marcadas con "WHATSAPP CHECKOUT".
// ============================================================
//
// >>> EDITA AQUÍ PARA CAMBIAR EL NÚMERO <<<
const WHATSAPP_NUMBER = '573004520708'; // sin + ni espacios
// >>> ----------------------------------- <<<

(function () {
  // 0) Bandera para el resto del tema. El carrito lateral la lee para saber si
  //    el boton de pagar acaba en WhatsApp o en el checkout de Shopify, y
  //    corregir su propio texto si el ajuste de la seccion no coincide. Al
  //    borrar este archivo la bandera desaparece y el carrito vuelve solo a
  //    anunciar el checkout de Shopify.
  window.saundaryaWhatsappCheckout = true;

  // 1) Ocultar botones express de Shopify (Shop Pay / Apple Pay / GooglePay)
  const style = document.createElement('style');
  style.textContent = `
    .shopify-payment-button,
    .additional-checkout-buttons,
    .nebula-cart__dynamic-checkout { display: none !important; }
  `;
  document.head.appendChild(style);

  // 2) Formatear precio en pesos colombianos (cart.js devuelve en céntimos)
  function formatPrice(cents) {
    const value = (cents / 100);
    return '$' + value.toLocaleString('es-CO', { maximumFractionDigits: 0 });
  }

  // 3) Construir mensaje de WhatsApp a partir del carrito
  function buildMessage(cart) {
    const origin = window.location.origin;
    const lines = [];
    lines.push('¡Hola! Quiero hacer este pedido:');
    lines.push('');
    cart.items.forEach((item, i) => {
      lines.push(`${i + 1}. *${item.product_title}*`);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        lines.push(`   Variante: ${item.variant_title}`);
      }
      lines.push(`   Cantidad: ${item.quantity}`);
      lines.push(`   Precio: ${formatPrice(item.price)} c/u`);
      lines.push(`   Subtotal: ${formatPrice(item.line_price)}`);
      if (item.url) lines.push(`   Link: ${origin}${item.url}`);
      lines.push('');
    });
    lines.push(`*TOTAL: ${formatPrice(cart.total_price)}*`);
    lines.push('');
    lines.push('¿Me pueden confirmar disponibilidad y forma de pago?');
    return lines.join('\n');
  }

  // 4) Disparador: obtener carrito y redirigir
  async function redirectToWhatsApp(triggerEl) {
    try {
      if (triggerEl) triggerEl.disabled = true;
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      if (!cart.items || cart.items.length === 0) {
        alert('Tu carrito está vacío.');
        if (triggerEl) triggerEl.disabled = false;
        return;
      }
      const text = encodeURIComponent(buildMessage(cart));
      window.location.href = `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
    } catch (err) {
      console.error('[WA-checkout]', err);
      if (triggerEl) triggerEl.disabled = false;
      alert('No pudimos abrir WhatsApp. Inténtalo de nuevo.');
    }
  }

  // 5) Interceptar CLICK en cualquier botón name="checkout"
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    redirectToWhatsApp(btn);
  }, true);

  // 6) Interceptar SUBMIT (por si envían el form con Enter)
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form) return;
    const id = form.id || '';
    const isCartForm = id === 'cart' || id === 'CartDrawer-Form' || id === 'cart-notification-form';
    if (!isCartForm) return;
    e.preventDefault();
    redirectToWhatsApp(e.submitter || null);
  }, true);
})();
